import {
    DefaultCellTypes,
    CellStyle,
    NumberCell,
    TextCell,

    Column,
    Row,
    HeaderCell
} from "@silevis/reactgrid";


import { RenderFunction } from "data/reporting/report/render";
import { Format, FormatBorder } from "data/reporting/report/format";
import { Formatter } from "data/reporting/report//formatter";

const initialCSS = `
width: 1523 
font-family: "DM Sans", sans-serif;

.reactgrid-content .rg-pane .rg-cell {
    padding: 4px 4px;
    border-left: none;
    border-right: none;
}
  

.padding-left-lg {
    padding-left: 24px !important;
}

.reactgrid-content .rg-pane .rg-cell-focus {
    border-color: #2797ff;
    border-width: 2px;
}

.reactgrid-content .rg-pane .rg-cell-focus {
    border-color: #2797ff;
    border-width: 2px;
}
    
`

type ComposedStyle = {
    className: string
    style: CellStyle
}


const { define: defineCellStyle, list: listCellStyles } = Formatter((obj: CellStyle) => JSON.stringify(obj), (o1, o2) => { throw new Error() })
const { define: defineStyle, list: listStyles } = Formatter((obj: ComposedStyle) => JSON.stringify(obj), (o1, o2) => { throw new Error() })


const emptyCell = (
    { className, style }: ComposedStyle
): TextCell => ({
    type: "text",
    text: "",
    className,
    style
});

const numberFormat = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});

const textCell = (
    text: string,
    { className, style }: ComposedStyle
): TextCell => ({
    type: "text",
    text,
    className,
    style
});

const numberCell = (
    value: number,
    { className, style }: ComposedStyle
): NumberCell => ({
    type: "number",
    value,
    className,
    style,
    format: numberFormat,
    nanToZero: true,
    hideZero: false
});

const nonEditable = (cell: DefaultCellTypes): DefaultCellTypes => ({
    ...cell,
    nonEditable: true
});

type RG_GridData = { css: string, props: { columns: Column[], rows: Row[], stickyTopRows: number, stickyLeftColumns: number } };

const s: CellStyle = { border: { top: {} } }
function convertBorder(border?: FormatBorder) {
    if (border && border.style) {
        const { style, color: fColor } = border;
        const color: string = fColor || "#000000"
        if (style == 'double')
            return { width: '3px', style: "double", color }
        else if (style == 'single')
            return { width: '1px', style: "solid", color }
    } else {
        return { style: "none" }
    }

}
export const RenderRG: RenderFunction<RG_GridData> = () => {
    const composedMap = new Map<Format, ComposedStyle>();
    const cssDict: { [css: string]: string } = {};
    let nextStyleNum = 1;
    let css = initialCSS;
    function getStyleClass(cellCSS: string) {
        if (cellCSS in cssDict)
            return cssDict[cellCSS]
        else {
            const className = `cell-inline-${nextStyleNum++}`
            css += `.reactgrid-content .rg-pane .${className} ${cellCSS}`
            return (cssDict[cellCSS] = className);
        }
    }
    function getComposedStyle(format: Format) {
        let c = composedMap.get(format);
        if (c)
            return c;
        const { top, left, right, bottom } = format.borders || {}
        const { size, italic, bold, color: fontColor, align } = format.text || {}
        const { color: fillColor } = format.fill || {}
        return ({
            className: getStyleClass(`${`{`
                }${size ? `\n    font-size: ${size}px;` : ``
                }${bold ? `\n    font-weight: bold;` : ``
                }${italic ? `\n    font-style: italic;` : ``
                }${align ? `\n    justify-content: ${align};` : ``
                }}`),
            style: {
                color: fontColor,
                background: fillColor,
                border: format.borders ? {
                    top: convertBorder(top),
                    left: convertBorder(left),
                    right: convertBorder(right),
                    bottom: convertBorder(bottom)
                } : undefined
            } as CellStyle
        })

    }


    let stickyTopRows: number = 0;
    let stickyLeftColumns: number = 0;
    let oneSheet = false;
    let resultColumns: Column[]
    let overflowCell: TextCell | null = null
    let overflowIndex: number = 0
    function finishOverflow(ci: number) {
        if (overflowCell && (ci > overflowIndex)) {
            (overflowCell as unknown as HeaderCell).type = "header";
            (overflowCell as unknown as HeaderCell).colspan = ci - overflowIndex + 1;
        }
        overflowCell = null
    }
    const resultRows: Row[] = []
    let currentRow: Row;
    let blankCell: DefaultCellTypes;
    function fillCellsTo(ci: number) {
        const { cells } = currentRow;
        while (ci > cells.length)
            cells.push(blankCell)
    }
    return {
        addSheet({ name }) {
            if (!oneSheet) oneSheet = true; else throw new Error();
        },
        setColumns(columns) {
            resultColumns = columns.map(({ width, id, freeze }, ci) => {
                if (freeze) stickyLeftColumns = (ci + 1);
                return ({ width, columnId: id || ci })
            });
        },
        addRow({ id, height, format }) {
            if (currentRow) {
                fillCellsTo(resultColumns.length)
                finishOverflow(resultColumns.length)
            }
            const ri = resultRows.length;
            resultRows.push((currentRow = { rowId: id || ri, height, cells: [] }))
            blankCell = emptyCell(getComposedStyle(format));
        },
        freezeRow() {
            stickyTopRows = resultRows.length;
        },
        addCell({ ci, format, value, formula }) {
            fillCellsTo(ci)
            const composed = getComposedStyle(format)
            const cell = typeof value == 'string'
                ? textCell(value, composed)
                : typeof value == "number"
                    ? numberCell(value, composed)
                    : emptyCell(composed)
            currentRow.cells.push(cell)
            if (typeof value !== undefined) {
                finishOverflow(ci - 1)
                const align = format?.text?.align
                if (cell.type == "text" && (!align || align == "left")) {
                    overflowCell = cell
                    overflowIndex = ci
                }

            }
        },
        finish() {
            stickyLeftColumns = stickyLeftColumns;
            stickyTopRows = stickyTopRows;
            if (currentRow) {
                fillCellsTo(resultColumns.length)
                finishOverflow(resultColumns.length)
            }
            return { css, props: { rows: resultRows, columns: resultColumns, stickyLeftColumns, stickyTopRows } }
        }
    }
}
